import * as React from "react";
import classnames from "classnames";
import { Text } from "@grandvisionhq/elements";
import { Address } from "@grandvisionhq/locations";
/* empty css                   */
const StoreOverview = ({
  className,
  labels,
  mapImageUrl,
  addressData,
  phoneHidden,
  emailHidden,
  email,
  storeDetailLink,
  phone,
  ...rest
}) => /* @__PURE__ */ React.createElement("div", { ...rest, className: classnames("store-overview", className) }, /* @__PURE__ */ React.createElement(
  "img",
  {
    className: "store-overview__map",
    src: mapImageUrl,
    alt: addressData.storeName,
    "data-t": "staticMapImage"
  }
), /* @__PURE__ */ React.createElement("div", { className: "store-overview__content" }, /* @__PURE__ */ React.createElement(Text, { variant: "body-head", className: "store-overview__store-name" }, addressData.storeName), /* @__PURE__ */ React.createElement(Address, { data: addressData, className: "store-overview__address" }, /* @__PURE__ */ React.createElement("div", { className: "store-overview__contact" }, !phoneHidden && phone && /* @__PURE__ */ React.createElement("div", { className: "store-overview__contact-field" }, /* @__PURE__ */ React.createElement("a", { href: `tel:${phone}`, "data-t": "phone" }, phone)), !emailHidden && email && /* @__PURE__ */ React.createElement("div", { className: "store-overview__contact-field" }, /* @__PURE__ */ React.createElement("a", { href: `mailto:${email}`, "data-t": "email" }, email)))), /* @__PURE__ */ React.createElement("a", { target: "_blank", rel: "noreferrer", href: storeDetailLink }, labels.storeDetailLink)));
export {
  StoreOverview as default
};
//# sourceMappingURL=StoreOverview.js.map
